import { api } from 'api'
import { useQuery } from '@tanstack/react-query'
import { toaster } from 'uikit/Toaster'

export const useFetchEkengHistory = (userId: string) => {
  const response = useQuery({
    queryKey: ['useFetchEkengHistory', userId],
    queryFn: () => api.users.fetchEkengById(userId),
    gcTime: 0,
  })

  if (response.isError) {
    toaster.create({
      type: 'error',
      title: 'Произошла ошибка при загрузке конфигурации провайдеров',
      description: response.error?.message,
    })
  }

  const data = response.data as any
  const hasData = data?.originalEkengData || data?.latestEkengData
  
  const originalEkengData = data?.originalEkengData
    ? { ...data.originalEkengData, updatedAt: data.originalRequestDate }
    : {}
  const latestEkengData = data?.latestEkengData ? data?.latestEkengData : {}

  return {
    ...response,
    data: hasData ? [originalEkengData, latestEkengData] : [],
  }
}
